import type { RestaurantWithEventSpaces } from "@/types/restaurant";
import { getNeighborhoodDisplay } from "@/utils/neighborhoodFormatting";

interface CardHeaderProps {
  restaurant: RestaurantWithEventSpaces;
  hideHeader?: boolean;
}

export const CardHeader = ({ restaurant, hideHeader = false }: CardHeaderProps) => {
  if (hideHeader) return null;
  
  return (
    <div className="p-4 pb-2">
      <h3 className="text-lg font-semibold text-primary leading-tight mb-1">{restaurant.name}</h3>
      <p className="text-sm text-muted-foreground">
        {getNeighborhoodDisplay(restaurant.neighborhood)}
      </p>
    </div>
  );
};